<script>
    import Button from "./Button.svelte";
    import License from "./License.svelte";
    import PrivacyPolicy from "./PrivacyPolicy.svelte";
</script>

<div id="privacy-policy-popup">
    <div id="exit-btn">
        <Button
            on:click={() => {
                window.fullyExitGame();
            }}
            type="button"
            text={"X"}
            style="width:65px"
        />
    </div>
    <div class="tldr">
        Spellmasons sends logs and errors to a server in order to improve the
        game experience and resolve bugs.
        <br />
        We do not collect sensitive personal information.
        <br />
        <span> Full legally binding Privacy Policy and EULA below: </span>
    </div>
    <div id="legal-content" class="flex">
        <div class="legal">
            <PrivacyPolicy />
        </div>
        <div class="legal">
            <License />
        </div>
    </div>
    <div id="accept-btn-wrapper">
        <Button
            text="Accept"
            class="accept-btn justify-center"
            on:click={() => {
                if (globalThis.acceptPrivacyPolicyAndEULA) {
                    globalThis.acceptPrivacyPolicyAndEULA();
                } else {
                    console.error(
                        "Unexpected: No acceptPrivacyPolicyAndEULA function",
                    );
                }
            }}
        />
    </div>
</div>

<style global>
    .tldr {
        font-size: 1.2em;
        text-align: center;
        max-width: 600px;
        margin: 0 auto;
    }
    .tldr span {
        font-size: 1rem;
    }
    .accept-btn {
        max-width: 240px;
    }
    #accept-btn-wrapper {
        display: flex;
        width: 100%;
        justify-content: center;
        margin: 2em 0;
    }
    #exit-btn {
        margin: 2em;
        display: flex;
        flex-direction: row-reverse;
    }
    #privacy-policy-popup {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: none;
        background-color: #171717;
        z-index: 1;
    }
    #privacy-policy-popup.show {
        display: flex;
        flex-direction: column;
        gap: 2em;
    }
    #legal-content {
        background-color: #171717;
        gap: 2em;
        width: 80%;
        margin: 0 auto;
        overflow: hidden;
    }
    #legal-content .legal {
        color: black !important;
        background: white;
        width: 50%;
        overflow-y: scroll;
        padding: 2em;
    }
</style>
